import { createStyles, makeStyles } from "@mui/styles";

const sharedDropDownBoxStyles = {
  height: 32,
  borderRadius: 2,
  gap: 4,
  width: "100%",
  "& input::placeholder": {
    fontFamily: "Segoe UI",
    fontWeight: 400,
    fontStyle: "italic",
    fontSize: 12,
    lineHeight: "16px",
    letterSpacing: 0,
    color: "#6E6E6E",
    opacity: 1
  },
  "&.dx-dropdowneditor-icon": {
    width: 16,
    height: 16,
    color: "#464646",
    transform: "rotate(0deg)"
  },
  "&.dx-texteditor .dx-texteditor-container": {
    alignItems: "center",
    padding: 8
  },
  ".dx-texteditor-input-container": {
    alignItems: "center"
  },
  "&.dx-texteditor.dx-editor-filled .dx-texteditor-input": {
    color: "#1E1E1E !important",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: "16px",
    fontFamily: "Segoe UI",
    padding: 0
  },
  "&.dx-texteditor.dx-editor-filled::after": {
    borderBottom: "none !important"
  },
  "&.dx-texteditor.dx-editor-filled .dx-placeholder::before": {
    content: "none"
  },
  "&.dx-dropdowneditor.dx-dropdowneditor-field-clickable": {
    padding: 0
  },
  "&.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-dropdowneditor-button":
    {
      width: 16,
      minWidth: 16,
      marginRight: 0
    },
  "&.dx-editor-filled .dx-texteditor-buttons-container:last-child > .dx-dropdowneditor-button .dx-dropdowneditor-icon":
    {
      color: "#464646",
      width: 16
    },
  "&.dx-texteditor.dx-state-hover": {
    border: "solid 2px #828282"
  },
  "&.dx-texteditor.dx-state-focused": {
    border: "solid 2px #0F789B"
  },
  "&.dx-texteditor.dx-state-focused::before": {
    borderBottom: "none"
  },
  "&.dx-texteditor.dx-editor-filled.dx-state-readonly": {
    backgroundColor: "#0000000D !important",
    border: "none"
  }
};

export const useDropDownBoxStyles = makeStyles(theme =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column"
    },
    dropDownBox: {
      ...sharedDropDownBoxStyles,
      border: "solid 1px #828282",
      backgroundColor: "#ffffff !important"
    },
    dropDownBoxWithError: {
      ...sharedDropDownBoxStyles,
      border: "1px solid #DC0000",
      backgroundColor: "#DC00001A !important"
    }
  })
);
